"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueAtPath = exports.nuts = exports.squirrelListAdd = exports.squirrelSet = exports.squirrelRemove = exports.squirrelInvert = exports.squirrel = void 0;
function squirrel(path, map) {
    const [key, ...rest] = Array.isArray(path) ? path : path.split("/").reverse();
    if (rest.length)
        map = squirrel(rest, map);
    const F = (f) => (x) => Object.assign(Array.isArray(x) ? [] : {}, x || {}, {
        [key]: f((x || {})[key])
    });
    return map ? (x) => map(F(x)) : F;
}
exports.squirrel = squirrel;
const squirrelInvert = (path, map) => squirrel(path, map)((v) => !v);
exports.squirrelInvert = squirrelInvert;
const squirrelRemove = (path, map) => squirrel(path, map)(() => undefined);
exports.squirrelRemove = squirrelRemove;
const squirrelSet = (path, map) => (val) => squirrel(path, map)(() => val);
exports.squirrelSet = squirrelSet;
const squirrelListAdd = (path, map) => (val) => squirrel(path, map)((list) => [...list, val]);
exports.squirrelListAdd = squirrelListAdd;
function nuts(path, map) {
    const [key, ...rest] = Array.isArray(path) ? path : path.split("/").reverse();
    if (rest.length)
        map = nuts(rest, map);
    const F = (x) => (x ? x[key] : undefined);
    return map ? (x) => F(map(x)) : F;
}
exports.nuts = nuts;
function getValueAtPath(path, map) {
    const [key, ...rest] = Array.isArray(path) ? path : path.split(".").reverse();
    if (rest.length)
        map = getValueAtPath(rest, map);
    return map[key];
}
exports.getValueAtPath = getValueAtPath;
//# sourceMappingURL=index.js.map